// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.src-js-components-forms-TextAreaStyles-module__textArea--vxr5m {
  margin: 10px 0;
  background-color: #a8b0b8;
  border: 1px solid #ffffff;
  color: #ffffff;
}

.src-js-components-forms-TextAreaStyles-module__hidden--cLIU8 {
  display: none;
}
`, "",{"version":3,"sources":["webpack://./src/js/components/forms/TextAreaStyles.module.css"],"names":[],"mappings":";AACA;EACE,cAAc;EACd,yBAAyB;EACzB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,aAAa;AACf","sourcesContent":["\n.textArea {\n  margin: 10px 0;\n  background-color: #a8b0b8;\n  border: 1px solid #ffffff;\n  color: #ffffff;\n}\n\n.hidden {\n  display: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"textArea": `src-js-components-forms-TextAreaStyles-module__textArea--vxr5m`,
	"hidden": `src-js-components-forms-TextAreaStyles-module__hidden--cLIU8`
};
export default ___CSS_LOADER_EXPORT___;
